export const lockByTypes = ['App', 'Button Code', 'TSA Unlock', 'Auto Locked'];
